import { Component, HostBinding, inject, OnDestroy, signal } from '@angular/core';
import { Subscription } from 'rxjs';
import { UrlService } from '../services/url.service';
import { DatasnapUrlService } from '../services/datasnap-url.service';

@Component({
	selector: 'app-dashboard-header',
	templateUrl: './dashboard-header.component.html',
	styleUrls: ['./dashboard-header.component.scss'],
	imports: [],
})
export class DashboardHeaderComponent implements OnDestroy {
	protected readonly urlService = inject(UrlService);
	protected readonly datasnapUrlService = inject(DatasnapUrlService);

	readonly dashboardName = signal('');

	@HostBinding('class.disabled')
	get disabled() {
		return this.datasnapUrlService.isViewingSnapshot();
	}

	protected subscriptions: Subscription[] = [];

	constructor() {
		this.subscriptions.push(this.urlService.routeData$.subscribe((routeData) => this.dashboardName.set(routeData.title)));
	}

	ngOnDestroy() {
		for (const sub of this.subscriptions) sub.unsubscribe();
	}
}
